import isEqual from 'lodash/isEqual';
import React from 'react';
import dayjs from "dayjs";


// src/helpers/rentalHelper.js
const resolveCondition = (fieldValue ,condition)=>{
  if (!fieldValue){
    fieldValue = false
  }
   condition = JSON.parse(condition)
      switch (condition[0]){
        case "is":
          if (fieldValue.toString() === condition[1]){
            return true
          }
          break
        case "not":
          if ( fieldValue.toString() !== condition[1]){
            return true
          }
          break
      }
      return false
}
const checkEqual = (val1, val2)=>{
  return isEqual(val1 , val2)
}
const toDayjs = (date) => {
  return dayjs(date)
}
const isoDateToDate = (isoString , time = true) => {
  const date = new Date(isoString);
  const hasTime = date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;
  const dateOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  const dateTimeOptions = {
    ...dateOptions,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };

  return date.toLocaleString(
    "en-GB",
    hasTime && time ? dateTimeOptions : dateOptions
  );
};
const firstLetterCaps = (str , onlyCaps = false) => {
  if (!str) return;
  try{
  if (!onlyCaps){
  str = str.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
  }
  str = str.charAt(0).toUpperCase() + str.slice(1);
} catch {return str}
  return str;
};

const trimToEllipsis = (str, limit = 100) => {
  const shortDesc = str && str.length > limit ? str.slice(0, 100) + "..." : str;
  return shortDesc;
};
const safePeek = (obj, path, i = 0) => {
  if (i == path.length - 1) {
    return obj[path[i]];
  } else {
    if (!(path[i] in obj)) {
      return;
    }
    return safePeek(obj[path[i]], path, i + 1);
  }
};
const getMonthRange = (monthYearStr, iso = false) => {
  const [monthName, year] = monthYearStr.split(' ');

  // Avoid locale weirdness by parsing clearly
  const base = new Date(`${monthName} 1, ${year}`);

  // Local boundaries (important: set hours so lastDay doesn’t roll over in TZ conversions)
  const firstDay = new Date(base.getFullYear(), base.getMonth(), 1, 0, 0, 0, 0);
  const lastDay  = new Date(base.getFullYear(), base.getMonth() + 1, 0, 23, 59, 59, 999);

  if (!iso) {
    return { firstDay, lastDay };
  }

  // ISO-safe date-only (prevents UTC shift in transport)
  const toISO = (d) => d.toISOString()

  return {
    firstDay: toISO(firstDay),
    lastDay: toISO(lastDay)
  };
};

function getRandomColor(dark = false) {
  let r, g, b;

  if (dark) {
    // DARK BLUE SHADE
    r = Math.floor(Math.random() * 30);      // 0–29
    g = Math.floor(Math.random() * 30);      // 0–29
    b = Math.floor(Math.random() * 156) + 100; // 100–255
  } else {
    // LIGHT / BRIGHT BLUE SHADE
    r = Math.floor(Math.random() * 100) + 80; // 80–179
    g = Math.floor(Math.random() * 100) + 80; // 80–179
    b = Math.floor(Math.random() * 80) + 150; // 150–229
  }

  const toHex = (c) => ('0' + c.toString(16)).slice(-2);
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}


const getCurrentMonthYear = () => {
  const now = new Date();
  const month = now.toLocaleString('default', { month: 'long' });
  const year = now.getFullYear();
  return `${month} ${year}`;
};
function clampDatesToMonth(startDate, endDate, monthYearStr) {
  const { firstDay, lastDay } = getMonthRange(monthYearStr);
  const start = new Date(startDate);
  const end = new Date(endDate);

  const clampedStart = start < firstDay ? new Date(firstDay) : start;

  // If the original end date is after the last day of the month,
  // set the clamped end date to the first day of the NEXT month.
  // This is required for react-big-calendar to render the last day correctly.
  let clampedEnd;
  if (end > lastDay) {
    const nextDay = new Date(lastDay);
    nextDay.setDate(lastDay.getDate() + 1);
    clampedEnd = nextDay;
  } else {
    clampedEnd = end;
  }

  return { startDate: clampedStart, endDate: clampedEnd };
}
function debounce(func, timeout = 2000){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
function monthYearStrToDate(monthYearStr) {
  // Expects format "June 2025"
  const [monthName, year] = monthYearStr.split(" ");
  const month = new Date(`${monthName} 1, ${year}`).getMonth();
  return new Date(Number(year), month, 1);
}
function isEmpty(value){
  try{
    return Object.keys(value).length === 0
  }
  catch {
    return false
  }
}
function uuid6() {
  return Math.random().toString(36).slice(2, 8);
}
const getAllDatesInMonth = (monthYearStr) => {
  const date = monthYearStrToDate(monthYearStr);
  const year = date.getFullYear();
  const month = date.getMonth();

  const dates = [];
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  for (let day = 1; day <= daysInMonth; day++) {
    const currentDate = new Date(year, month, day, 12, 0, 0); // Set time to noon to avoid timezone issues
    dates.push(currentDate.toISOString().split('T')[0]); // Format as YYYY-MM-DD
  }

  return dates;
};
function filterIfContains(arr=[] , keyword , keys=[]){
  // keys = new Set(keys)
  let newArr = []
  for (var el of arr){
    let flag = 1
    for (var key of keys){
      if (key in el){
        if (el[key].indexOf(keyword) == -1){
          flag = 0
          break
        }
      }
    }
    if (flag == 1){
      newArr.push(el)
    }
  }
  return newArr
}
const toYMD = (d) => {
  if (!d) return d;

  if (typeof d === "string") {
    return d.slice(0, 10);
  }

  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
};

const toLocalISOString = (d) => {
  if (!d) return d;

  let year, month, day;

  if (typeof d === "string") {
    [year, month, day] = d.slice(0, 10).split("-");
  } else {
    year = d.getFullYear();
    month = String(d.getMonth() + 1).padStart(2, "0");
    day = String(d.getDate()).padStart(2, "0");
  }

  // No UTC conversion — date stays exactly as selected
  return `${year}-${month}-${day}T00:00:00.000Z`;
};

const normalizeDates = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(item => normalizeDates(item));
  }
  if (obj && typeof obj === 'object' && !(obj instanceof Date)) {
    const result = {};
    Object.keys(obj).forEach(key => {
      if (
        key.toLowerCase().endsWith('date') &&
        obj[key] &&
        (typeof obj[key] === 'string' || obj[key] instanceof Date)
      ) {
        result[key] = toLocalISOString(obj[key]);
      } else {
        result[key] = normalizeDates(obj[key]);
      }
    });
    return result;
  }
  return obj;
};
function getDatesBetween(startDate, endDate) {
  // extract calendar parts WITHOUT timezone conversion


  // build initial YMD for both dates
  const startYMD = startDate;
  const endYMD =endDate;

  // convert YMD back to "safe" Date objects (these won't shift)
  const [sy, sm, sd] = startYMD.split("-").map(Number);
  const [ey, em, ed] = endYMD.split("-").map(Number);

  let cur = new Date(sy, sm - 1, sd); // local date, midnight, safe
  const end = new Date(ey, em - 1, ed);

  const dates = [];

  while (cur <= end) {
    dates.push(toYMD(cur)); // push YYYY-MM-DD
    cur.setDate(cur.getDate() + 1);
  }

  return dates;
}


function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
function transformType(key , value){
  key = key.toLowerCase()
  if(key.endsWith("date")){
    return isoDateToDate(value,false)
  } if (typeof value == "boolean"){
    return value ? "Yes":"No"
  }
  return value

}
function isNumber(str) {
  if (typeof str === "string" && str.trim() === "") return false; // empty string is not a number
  return !isNaN(str);
}

function generateUUID(n=6){
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < n; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function getCookie(name) {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (decodeURIComponent(key) === name) {
      return decodeURIComponent(value);
    }
  }

  return null;
}
function setCookie(name, value, hours = 8) {
  const expires = new Date(Date.now() + hours * 3600000).toUTCString();
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict`;
}
/**
 * Recursively validates an object ensuring no empty values exist,
 * except for keys listed in exceptions.
 *
 * Empty objects `{}` are allowed.
 *
 * @param {Object} obj - The object to validate.
 * @param {string[]} [exceptions=[]] - Keys that are allowed to be empty.
 * @param {string} [parentKey=''] - Internal use for nested key tracking.
 * @returns {{ valid: boolean, emptyKeys: string[] }}
 */
function validateObjectValues(obj, exceptions = [], parentKey = '') {
  let emptyKeys = [];

  const isEmptyValue = (val) =>
    val === null ||
    val === undefined ||
    val === '' ||
    (Array.isArray(val) && val.length === 0); // ⬅️ removed object-empty check

  for (const [key, value] of Object.entries(obj)) {
    const fullKey = parentKey ? `${parentKey}.${key}` : key;

    // Skip exception keys
    if (exceptions.includes(fullKey) || exceptions.includes(key)) continue;

    // Check for emptiness
    if (isEmptyValue(value)) {
      emptyKeys.push(fullKey);
    } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      // Recurse into nested objects
      const result = validateObjectValues(value, exceptions, fullKey);
      emptyKeys = [...emptyKeys, ...result.emptyKeys];
    }
  }

  return {
    valid: emptyKeys.length === 0,
    emptyKeys,
  };
}

function getFromPreload(preloadData,preloadPath){
    var preload  = {...preloadData}
    for (var path of preloadPath.split('.')){
      if (path == 'preload'){
        continue
      }
      if (!(path in preload)){
        return undefined
      }
      preload = preload[path]
    }

    if (typeof preload === "string"){
      return JSON.parse(preload)
    }
    return preload
}
const transformArray = (arr, valuesToRemove = [], replaceMap = {}) => {
  return arr
    .filter(item => !valuesToRemove.includes(item))        // remove unwanted
    .map(item => replaceMap[item] ?? item);                // replace if exists
};

/**
 * Safely parses JSON if it's a string, otherwise returns the original value.
 * @param {*} value - The input value to check and possibly parse.
 * @param {*} fallback - Optional fallback if parsing fails or value is nullish.
 * @returns {*} Parsed object if string JSON, otherwise original or fallback.
 */
function safeParse(value, fallback = {}) {
  let result;

  if (typeof value === 'string') {
    try {
      result = JSON.parse(value);
    } catch {
      result = fallback;
    }
  } else {
    result = value ?? fallback;
  }

  // Always clone to avoid frozen / sealed objects
  return JSON.parse(JSON.stringify(result));
}


function getFromWorkspace(workspaceData , key , transform = ""){
    if (key.startsWith("workspace.")) key = key.replace("workspace.","")
    if (transform == ""){
      return workspaceData[key]
    }
    if (transform == "select"){
      const data = Object.keys(workspaceData[key]).map((item)=>{
        return {
          key : item ,
          label : workspaceData[key][item]['name'],
          value : item
        }
      })
      return data
    }
}

function getDaysDifference(targetDateString) {
    const today = new Date();
    const targetDate = new Date(targetDateString);

    // Set hours, minutes, seconds, and milliseconds to 0 for accurate day difference calculation
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const todayMs = today.getTime();
    const targetDateMs = targetDate.getTime();

    const differenceMs = targetDateMs - todayMs;
    const millisecondsInADay = 1000 * 60 * 60 * 24;

    const differenceDays = Math.floor(differenceMs / millisecondsInADay); // Rounds down to the nearest whole day
    return differenceDays;
}
const hasAllKeys = (obj, keys) => keys.every(key => key in obj);
function chunkArray(arr, size = 200) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}
function arrayToDict(arr, keyField, valueField) {
  const dict = {};
  for (const item of arr) {
    let key = item[keyField]
    if (keyField.toLowerCase().endsWith('date')) {
  key = item[keyField].toISOString().slice(0, 10);
}

    dict[key] = item[valueField];

  }
  return dict;
}
const joinObjectValues = (obj,keys) =>{
  return keys.map(k => obj[k]).join(" - ");
}
const compareDates = (d1,d2)=>{
  if(dayjs(d1).isSame(d2)) return 0
  if(dayjs(d1).isBefore(d2)) return 1
  if(dayjs(d2).isBefore(d2)) return -1
}
function deleteCookie(name) {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}
export {
  joinObjectValues,
  toYMD,
  arrayToDict,
  chunkArray,
  getDatesBetween,
  getDaysDifference,
  transformArray,
  resolveCondition,
  safeParse,
  hasAllKeys,
  getFromWorkspace,
  uuid6,
  toDayjs,
  getFromPreload,
  validateObjectValues,
  generateUUID,
  isNumber,
  transformType,
  filterIfContains,
  usePrevious,
  isEmpty,
  monthYearStrToDate,
  clampDatesToMonth,
  getRandomColor,
  isoDateToDate,
  getCurrentMonthYear,
  getMonthRange,
  firstLetterCaps,
  trimToEllipsis,
  toLocalISOString,
  normalizeDates,
  safePeek,
  debounce,
  checkEqual,
  compareDates,
  getAllDatesInMonth,
  setCookie,
  getCookie,
  deleteCookie
};
